// 追従(CookiePolicy)の表示 // Display follow (CookiePolicy)
jQuery(function($) {
	// ヘッダー
	var headerHeight = $('#header').outerHeight();
	$('body').css('padding-top', headerHeight + 'px');

	// リサイズしたらヘッダー再取得
	$(window).on('resize', function() {
		headerHeight = $('#header').outerHeight();
		$('body').css('padding-top', headerHeight + 'px');
	});

	// モーダル
	$('.js-modal-open').click(function () {
    var id = $(this).data('id'); // 何番目のキャプション（モーダルウィンドウ）か認識
    $('#js-modal-overlay, .js-modal[data-id="modal' + id + '"]').fadeIn(200).css('display','flex');
  });
  // オーバーレイクリックでもモーダルを閉じるように
  $('.js-close , #js-modal-overlay').click(function () {
    $('#js-modal-overlay, .js-modal').fadeOut(200);
  });

	// フォーム
	$('.js-form-more-btn').click(function () {
    $('.js-form-hidden').fadeIn(200);
    $('.js-form-more-btn').hide();
  });


	// スクロールヒントの表示 // Display scroll hint
	if ( $('.js-scrollable').length > 0 ) {
    new ScrollHint('.js-scrollable');
	}


});


// アコーディオンの起動 // Activate the accordion
jQuery(function($) {
	if ( $('.accordion').length > 0 ) {
		$(".accordion .toggle").click(function(){
			$(this).next(".contents").slideToggle();
			$(this).toggleClass("open");
		});
	}
});

// ドロワーメニュー // Drawer menu
jQuery(function($) {
    if ($('#toggle').length > 0) {
		$('#toggle').click(function () {
			$(this).toggleClass('toggle_active');
			$('#drawer_layer').fadeToggle();
			$('body').toggleClass('drawer_open');

			if ($(this).hasClass('toggle_active')) {
				$('nav').addClass('is_open');
				$('nav').removeClass('is_close');
			} else {
				$('nav').removeClass('is_open');
				$('nav').addClass('is_close');
			}
		});

		$('#drawer_layer').click(function () {
			$(this).fadeOut();
			$('#toggle').removeClass('toggle_active');
			$('body').removeClass('drawer_open');
			$('nav').removeClass('is_open');
			$('nav').addClass('is_close');
		});

		// エリア内リンク用 // For links within an area
		$('nav a').on('click', function(){
			// if (window.innerWidth <= 768) {
			if ($('#toggle:visible').length > 0) {
				$('#toggle').click();
			}
		});
	}

});


jQuery(function ($) {
//二重送信抑制
	let submitBtn = $("input[type='submit'].wpcf7-submit");
	submitBtn.click(function () {
		$(this).css('pointer-events', 'none');
		$(this).css('opacity', '0.5');
	})
	// 入力項目にエラーがあったらボタン復活
	document.addEventListener('wpcf7invalid', function () {
		submitBtn.css('pointer-events', 'auto');
		submitBtn.css('opacity', '1');
	}, false);

});


jQuery(window).on('scroll', function () {
	if (jQuery(this).scrollTop() > 500 && jQuery(this).scrollTop() < (jQuery(document).height() - jQuery(window).height() - 500)) {
    jQuery(".c-floating").fadeIn()
} else {
    jQuery(".c-floating").fadeOut()
}
})

jQuery(function ($) {
	jQuery(".c-floating__close").click(function () {
		jQuery(".c-floating").remove()
	})
});

jQuery(function ($) {
  var $cta = $('.cta-fixed');
  var showPoint = 100;
  var $footer = $('footer');
  if (!$footer.length) {
    $footer = $('.footer');
  }

  function toggleCta() {
    var $win = $(window);
    var scrollTop = $win.scrollTop();
    var winHeight = $win.height();
    var winWidth  = $win.width();

    var footerTop = $footer.length ? $footer.offset().top : Infinity;
    var reachedFooter = scrollTop + winHeight >= footerTop;

    if (winWidth < 767) {

      if (reachedFooter) {
        if ($cta.hasClass('is-show')) {
          $cta.stop(true, true).fadeTo(300, 0, function () {
            $cta.removeClass('is-show');
          });
        }
        return;
      }

      if (scrollTop > showPoint) {
        if (!$cta.hasClass('is-show')) {
          $cta
            .addClass('is-show')
            .stop(true, true)
            .fadeTo(300, 1);
        }
      } else {
        if ($cta.hasClass('is-show')) {
          $cta
            .stop(true, true)
            .fadeTo(300, 0, function () {
              $cta.removeClass('is-show');
            });
        }
      }

    } else {
      $cta.hide().removeClass('is-show').css('opacity', 0);
    }
  }

  $(window).on('scroll resize', toggleCta);

  toggleCta();
});

jQuery(function ($) {
	$(".tab-btn").on("click", function () {
		var target = $(this).data("tab");
		
		$(".tab-content").removeClass("active");
		$(".tab-btn").removeClass("active");

		$("#" + target).addClass("active");
		$(this).addClass("active");
    });
});

